import { validateFilters } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { submitValuationForm } from '../../../actions/submitValuationForm';
import { TThunkDispatch } from '../../../types/redux';

/**
 * Если фильтры валидны - сабмитим форму и ведем на оценку ЖК
 * если фильтры не заполнены/не доконца - покажем ошибку валидации фильтров
 */
export function useHandleJKSubmit() {
  const dispatch = useDispatch<TThunkDispatch>();

  return React.useCallback(async () => {
    const isValidMainFilters = await dispatch(validateFilters());

    if (isValidMainFilters) {
      dispatch(submitValuationForm());
    }
  }, [dispatch]);
}
